export default __webpack_public_path__ + "static/media/Hope_for_life.7b78bf57.png";